import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  ClinicalTrialNotificationHistoryState,
  FetchNotificationHistoryAction,
  FetchNotificationHistorySuccessAction,
  NotificationHistoryResponse,
} from './clinicalTrialNotificationHistory.types';
import {
  initialNotificationHistoryFiltersState,
  notificationHistoryFiltersSlice,
} from './notificationHistoryFilters.slice';

const emptyResponse: NotificationHistoryResponse = {
  content: [],
  totalElements: 0,
  totalPages: 0,
  size: 10,
  number: 0,
  first: true,
  last: true,
  numberOfElements: 0,
  empty: true,
};

const initialState: ClinicalTrialNotificationHistoryState = {
  loading: false,
  error: undefined,
  data: emptyResponse,
  filters: initialNotificationHistoryFiltersState,
};

const { actReq, actResolve, actReject } =
  makeActionCreator<ClinicalTrialNotificationHistoryState>();

export const clinicalTrialNotificationHistorySlice = createSlice({
  name: 'clinicalTrialNotificationHistory',
  initialState,
  reducers: {
    fetchNotificationHistory:
      actReq<FetchNotificationHistoryAction['payload']>('loading'),
    fetchNotificationHistorySuccess: actResolve<
      FetchNotificationHistorySuccessAction['payload']
    >('data', 'loading', 'error'),
    fetchNotificationHistoryFailure: actReject('error', 'loading'),

    toggleActiveFilters: (state, action) => {
      state.filters = notificationHistoryFiltersSlice.reducer(
        state.filters,
        notificationHistoryFiltersSlice.actions.toggleActiveFilters(
          action.payload
        )
      );
    },
    toggleSelectedFilters: (state, action) => {
      state.filters = notificationHistoryFiltersSlice.reducer(
        state.filters,
        notificationHistoryFiltersSlice.actions.toggleSelectedFilters(
          action.payload
        )
      );
    },
    setSelectedFilter: (state, action) => {
      state.filters = notificationHistoryFiltersSlice.reducer(
        state.filters,
        notificationHistoryFiltersSlice.actions.setSelectedFilter(
          action.payload
        )
      );
    },
    resetFilters: state => {
      state.filters = notificationHistoryFiltersSlice.reducer(
        state.filters,
        notificationHistoryFiltersSlice.actions.reset()
      );
    },
  },
});

export const actions = {
  ...clinicalTrialNotificationHistorySlice.actions,
};

export const useClinicalTrialNotificationHistorySlice = createSliceHook(
  clinicalTrialNotificationHistorySlice.name,
  actions
);
